<template>
  <div class="row mx-auto">
    <v-switch label="لوگو" v-model="type"/>
    <v-btn block outlined color="success" @click="addPersonnel">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <div v-if="!type" class="row mx-auto">
      <create-customer v-for="(item,index) in customer.items" :key="index" v-model="item.user"/>
    </div>

    <div v-if="type" class="row mx-auto">
      <create-logo-customer v-for="(item,index) in customer.items" :key="index" v-model="item.user"/>
    </div>
  </div>
</template>

<script>
import CreateCustomer from "@/view/components/Customer/CreateCustomer";
import CreateLogoCustomer from "@/view/components/Customer/CreateLogoCustomer";

export default {
  name: "Customer",
  components: {CreateLogoCustomer, CreateCustomer},
  props: {
    data: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      type: true,
      customer: {
        type: 'logo',
        items: []
      }
    }
  },
  methods: {
    addPersonnel() {
      this.customer.items.push({user: {}});
    },
  },
  watch: {
    customer: {
      deep: true,
      handler(value) {
        this.data['customer'] = value;
      }
    },
    type(value) {
      this.customer.type = value ? 'logo' : 'user';

      this.customer.items = [];
    }
  },
  mounted() {
    if (this?.data?.customer)
      this.customer = this?.data?.customer;
  }
}
</script>

<style scoped>

</style>